function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{display:none;fill:#C5B9AC;}\n\t.st1{display:none;}\n\t.st2{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: -5.7,
  y: -2.4,
  className: "st0",
  width: 764.5,
  height: 450
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "582.3,396.8 299.5,396.8 228.4,375.5 93.5,375.5 93.5,373.5 228.6,373.5 299.8,394.8 582.3,394.8 "
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "300.6,396 298.7,395.5 390.1,54.7 544.3,91.1 516.1,185.8 476.9,395.9 474.9,395.6 514.2,185.4  514.2,185.3 541.8,92.5 391.5,57.1 "
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M322.9,208.2l-58.4-22L313,58.6l55.8,17.9L322.9,208.2z M267,185l54.6,20.6l44.6-127.8l-52-16.7L267,185z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M282.4,357.7l-47.1-8.3l22.3-140.5l60.2,21.1l-0.2,0.9L282.4,357.7z M237.6,347.7l43.4,7.7l34.4-124.1 l-56.2-19.7L237.6,347.7z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M512.8,155.3H399.1V92.8h82.5v21.9h31.3V155.3z M401.1,153.3h109.7v-36.6h-31.3V94.8h-78.5V153.3z"
});

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 245.1,
  y: 135.4,
  className: "st2",
  width: 2.5,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 252.4,
  y: 135.4,
  className: "st2",
  width: 4.8,
  height: 2
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M295.7,137.4h-4.8v-2h4.8V137.4z M286.1,137.4h-4.8v-2h4.8V137.4z M276.5,137.4h-4.8v-2h4.8V137.4z  M266.9,137.4H262v-2h4.8V137.4z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 300.5,
  y: 135.4,
  className: "st2",
  width: 2.5,
  height: 2
}));

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 575.2,
  y: 125.6,
  className: "st2",
  width: 2.5,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 565.3,
  y: 125.6,
  className: "st2",
  width: 4.9,
  height: 2
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M560.4,127.6h-4.9v-2h4.9V127.6z M550.5,127.6h-4.9v-2h4.9V127.6z M540.7,127.6h-4.9v-2h4.9V127.6z  M530.8,127.6h-4.9v-2h4.9V127.6z M520.9,127.6H516v-2h4.9V127.6z M511.1,127.6h-4.9v-2h4.9V127.6z M501.2,127.6h-4.9v-2h4.9V127.6 z M491.3,127.6h-4.9v-2h4.9V127.6z M481.5,127.6h-4.9v-2h4.9V127.6z M471.6,127.6h-4.9v-2h4.9V127.6z M461.8,127.6h-4.9v-2h4.9 V127.6z M451.9,127.6H447v-2h4.9V127.6z M442,127.6h-4.9v-2h4.9V127.6z M432.2,127.6h-4.9v-2h4.9V127.6z M422.3,127.6h-4.9v-2h4.9 V127.6z M412.5,127.6h-4.9v-2h4.9V127.6z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 400.1,
  y: 125.6,
  className: "st2",
  width: 2.5,
  height: 2
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M315.5,149.9c-7.5,0-13.6-6.1-13.6-13.6c0-7.5,6.1-13.6,13.6-13.6c7.5,0,13.6,6.1,13.6,13.6 C329.1,143.8,323,149.9,315.5,149.9z M315.5,124.8c-6.4,0-11.6,5.2-11.6,11.6s5.2,11.6,11.6,11.6s11.6-5.2,11.6-11.6 S321.9,124.8,315.5,124.8z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M386.9,140.2c-7.5,0-13.6-6.1-13.6-13.6c0-7.5,6.1-13.6,13.6-13.6s13.6,6.1,13.6,13.6 C400.5,134.1,394.4,140.2,386.9,140.2z M386.9,115.1c-6.4,0-11.6,5.2-11.6,11.6s5.2,11.6,11.6,11.6c6.4,0,11.6-5.2,11.6-11.6 S393.3,115.1,386.9,115.1z"
});

var _ref13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M126.1,105.2V120h-1.9v-14.8h-4.5v-0.9h10.9v0.9H126.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M137,120v-15.7h9.3v0.9h-7.4v4.9h7.4v0.9h-7.4v7.9h7.4v0.9L137,120L137,120z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M159.4,105.6c-0.6-0.4-1.2-0.6-2-0.6c-1.8,0-2.9,0.9-2.9,2.3c0,1.2,0.7,1.9,3.3,3.3c1.4,0.8,2.4,1.5,3.1,2 c0.9,0.8,1.5,2,1.5,3.2c0,2.7-2,4.4-5.5,4.4c0,0,1.4,0-0.1,0c-1.9-0.2-2.9-1-4-1.8v-1.1c0,0,0.7,0.6,1.7,1.2 c0.9,0.5,1.6,0.6,2.5,0.7c2.3-0.1,3.8-1.2,3.8-2.9c0-1.4-1.1-2.4-4.1-4.1c-1.8-0.9-2.7-1.6-3.2-2.2c-0.5-0.7-0.7-1.3-0.7-2 c0-2.2,2-3.8,4.8-3.8c1.4,0,2,0.4,3.4,1.4l0,1.1C160.9,106.7,160,106.1,159.4,105.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M183.5,112.1c0,4.5-3.4,8.1-7.7,8.1c-4.3,0-7.7-3.6-7.7-8c0-4.4,3.5-8,7.7-8 C180,104.2,183.5,107.8,183.5,112.1z M170.1,112.2c0,2,0.7,4,1.9,5.3c1.1,1.2,2.3,1.8,3.9,1.8c1.7,0,3.1-0.8,4.2-2.3 c0.9-1.2,1.5-3.1,1.5-4.8c0-4-2.5-7.1-5.7-7.1C172.6,105.1,170.1,108.2,170.1,112.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M198.6,120l-5.9-8.9h-1.2v8.9h-1.9v-15.7h6.4c1.9,0,3.4,1.5,3.4,3.4c0,1.9-1.5,3.4-3.4,3.4h-1.2l5.9,8.9H198.6 z M195,110.2c1.3,0,2.4-1.1,2.4-2.5c0-1.4-1.1-2.5-2.4-2.5h-3.5v4.9L195,110.2L195,110.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M220.9,112.1c0,4.5-3.4,8.1-7.7,8.1c-4.3,0-7.7-3.6-7.7-8c0-4.4,3.5-8,7.7-8 C217.4,104.2,220.9,107.8,220.9,112.1z M207.4,112.2c0,2,0.7,4,1.9,5.3c1.1,1.2,2.3,1.8,3.9,1.8c1.7,0,3.1-0.8,4.2-2.3 c0.9-1.2,1.5-3.1,1.5-4.8c0-4-2.5-7.1-5.7-7.1C209.9,105.1,207.4,108.2,207.4,112.2z"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M105.8,135.9h4.1c2,0,3.1,1.3,3.1,2.9s-1.1,2.9-3.1,2.9h-2.5v3.5h-1.6V135.9z M109.7,137.3h-2.2v3h2.2 c0.9,0,1.6-0.6,1.6-1.5S110.6,137.3,109.7,137.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M120.4,141.7h-1.6v3.5h-1.6v-9.3h4.1c1.8,0,3.1,1.2,3.1,2.9c0,1.7-1.1,2.6-2.2,2.7l2.3,3.7h-1.9L120.4,141.7z  M121,137.3h-2.2v3h2.2c0.9,0,1.6-0.6,1.6-1.5S121.9,137.3,121,137.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M128.7,135.9h6.4v1.4h-4.8v2.4h4.7v1.4h-4.7v2.6h4.8v1.4h-6.4V135.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M139.9,142.6c0.6,0.7,1.7,1.3,3,1.3c1.3,0,1.9-0.7,1.9-1.3c0-0.8-1-1.1-2.1-1.4c-1.5-0.4-3.3-0.8-3.3-2.8 c0-1.5,1.4-2.7,3.4-2.7c1.5,0,2.6,0.5,3.5,1.3l-0.9,1.2c-0.7-0.7-1.7-1.1-2.7-1.1c-1,0-1.6,0.5-1.6,1.2c0,0.7,1,1,2.1,1.2 c1.5,0.4,3.4,0.9,3.4,2.9c0,1.6-1.1,2.9-3.6,2.9c-1.7,0-3-0.6-3.8-1.5L139.9,142.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M150.7,135.9h6.4v1.4h-4.8v2.4h4.7v1.4h-4.7v2.6h4.8v1.4h-6.4V135.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M163.2,138.4v6.8h-1.6v-9.3h1.7l4.8,6.6v-6.6h1.6v9.3h-1.6L163.2,138.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M176.7,137.3h-2.8v-1.4h7.3v1.4h-2.8v7.9h-1.6V137.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M190.3,143.4h-4.4l-0.7,1.8h-1.8l3.7-9.3h2l3.7,9.3H191L190.3,143.4z M186.4,142h3.5l-1.8-4.7L186.4,142z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M198,137.3h-2.8v-1.4h7.3v1.4h-2.8v7.9H198V137.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M206.6,135.9h1.6v9.3h-1.6V135.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M217.4,135.7c2.8,0,4.8,2,4.8,4.8s-2,4.8-4.8,4.8c-2.8,0-4.8-2-4.8-4.8S214.6,135.7,217.4,135.7z M217.4,137.2 c-1.9,0-3.1,1.4-3.1,3.4c0,1.9,1.2,3.4,3.1,3.4c1.9,0,3.1-1.5,3.1-3.4C220.5,138.6,219.3,137.2,217.4,137.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M228.2,138.4v6.8h-1.6v-9.3h1.7l4.8,6.6v-6.6h1.6v9.3h-1.6L228.2,138.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M137.5,157.3c0-2.9,2.1-4.8,4.8-4.8c2,0,3.1,1,3.8,2.1l-1.4,0.7c-0.4-0.8-1.3-1.4-2.4-1.4 c-1.8,0-3.2,1.4-3.2,3.4s1.4,3.4,3.2,3.4c1.1,0,2-0.6,2.4-1.4l1.4,0.7c-0.7,1.1-1.9,2.1-3.8,2.1 C139.6,162.2,137.5,160.2,137.5,157.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M150.2,152.7h6.4v1.4h-4.8v2.4h4.7v1.4h-4.7v2.6h4.8v1.4h-6.4V152.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M162.7,155.2v6.8h-1.6v-9.3h1.7l4.8,6.6v-6.6h1.6v9.3h-1.6L162.7,155.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M176.2,154.1h-2.8v-1.4h7.3v1.4h-2.8v7.9h-1.6V154.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M188.1,158.5h-1.6v3.5h-1.6v-9.3h4.1c1.8,0,3.1,1.2,3.1,2.9c0,1.7-1.1,2.6-2.2,2.7l2.3,3.7h-1.9L188.1,158.5z  M188.7,154.1h-2.2v3h2.2c0.9,0,1.6-0.6,1.6-1.5S189.7,154.1,188.7,154.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M196.5,152.7h6.4v1.4h-4.8v2.4h4.7v1.4h-4.7v2.6h4.8v1.4h-6.4V152.7z"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M353.6,408.7h6.4v1.4h-4.8v2.4h4.7v1.4h-4.7v2.6h4.8v1.4h-6.4V408.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M372.6,410.8l-1.5,1.6l-1-1l2.7-2.7h1.4v9.3h-1.6V410.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M379.3,415.5c0.6,0.7,1.7,1.3,3,1.3c1.3,0,1.9-0.7,1.9-1.3c0-0.8-1-1.1-2.1-1.4c-1.5-0.4-3.3-0.8-3.3-2.8 c0-1.5,1.4-2.7,3.4-2.7c1.5,0,2.6,0.5,3.5,1.3l-0.9,1.2c-0.7-0.7-1.7-1.1-2.7-1.1c-1,0-1.6,0.5-1.6,1.2c0,0.7,1,1,2.1,1.2 c1.5,0.4,3.4,0.9,3.4,2.9c0,1.6-1.1,2.9-3.6,2.9c-1.7,0-3-0.6-3.8-1.5L379.3,415.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M392.2,410.2h-2.8v-1.4h7.3v1.4h-2.8v7.9h-1.6V410.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M413.2,416.3h-4.4l-0.7,1.8h-1.8l3.7-9.3h2l3.7,9.3h-1.8L413.2,416.3z M409.2,414.8h3.5l-1.8-4.7L409.2,414.8z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M417.8,408.7h1.9l2.8,7.6l2.8-7.6h1.9l-3.7,9.3h-2L417.8,408.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M431,408.7h6.4v1.4h-4.8v2.4h4.7v1.4h-4.7v2.6h4.8v1.4H431V408.7z"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M586.5,122h4.1c2,0,3.1,1.3,3.1,2.9s-1.1,2.9-3.1,2.9h-2.5v3.5h-1.6V122z M590.4,123.5h-2.2v3h2.2 c0.9,0,1.6-0.6,1.6-1.5S591.3,123.5,590.4,123.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M602.7,129.6h-4.4l-0.7,1.8h-1.8l3.7-9.3h2l3.7,9.3h-1.8L602.7,129.6z M598.8,128.1h3.5l-1.8-4.7L598.8,128.1z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M612.3,127.9h-1.6v3.5H609V122h4.1c1.8,0,3.1,1.2,3.1,2.9c0,1.7-1.1,2.6-2.2,2.7l2.3,3.7h-1.9L612.3,127.9z  M612.9,123.5h-2.2v3h2.2c0.9,0,1.6-0.6,1.6-1.5S613.8,123.5,612.9,123.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M623.1,127.4l-0.8,1v3h-1.6V122h1.6v4.5l3.7-4.5h2l-3.8,4.4l4.1,4.9h-2L623.1,127.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M632.1,122h1.6v9.3h-1.6V122z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M640.2,124.6v6.8h-1.6V122h1.7l4.8,6.6V122h1.6v9.3h-1.6L640.2,124.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M655.9,121.9c1.8,0,3,0.9,3.8,1.9l-1.3,0.8c-0.5-0.7-1.4-1.2-2.4-1.2c-1.8,0-3.2,1.4-3.2,3.4s1.4,3.4,3.2,3.4 c1,0,1.8-0.4,2.2-0.8v-1.5h-2.8v-1.4h4.4v3.5c-0.9,1-2.2,1.7-3.9,1.7c-2.7,0-4.9-1.9-4.9-4.8S653.2,121.9,655.9,121.9z"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M424,30.7c0.5,0.8,1.3,1.6,2.6,1.9c1.3,0.3,2-0.2,2.1-0.8c0.2-0.8-0.7-1.3-1.8-1.8c-1.4-0.7-3.1-1.5-2.6-3.5 c0.3-1.5,1.9-2.4,3.9-1.9c1.4,0.3,2.5,1,3.1,2l-1.2,1c-0.6-0.9-1.4-1.4-2.4-1.6c-0.9-0.2-1.6,0.1-1.8,0.8c-0.2,0.7,0.7,1.2,1.7,1.7 c1.4,0.7,3.1,1.6,2.7,3.6c-0.3,1.5-1.7,2.6-4.2,2c-1.7-0.4-2.8-1.2-3.4-2.3L424,30.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M440.7,30l-3.3,6.3l-1.7-0.4l-0.6-9.7l1.8,0.4l0.2,7.4l3.5-6.6l1.3,0.3l0.3,7.4l3.3-6.6l1.8,0.4l-4.6,8.5 l-1.7-0.4L440.7,30z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M451.1,29.8l1.6,0.4l-2,9.1l-1.6-0.4L451.1,29.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M459.2,33.1l-2.8-0.6l0.3-1.4l7.1,1.6l-0.3,1.4l-2.8-0.6l-1.7,7.7l-1.6-0.4L459.2,33.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M466.2,38c0.6-2.8,3.1-4.2,5.8-3.7c1.9,0.4,2.8,1.6,3.3,2.9l-1.5,0.4c-0.3-0.8-1-1.6-2.1-1.9 c-1.7-0.4-3.4,0.7-3.8,2.6c-0.4,1.9,0.6,3.6,2.3,4c1.1,0.2,2.1-0.1,2.7-0.8l1.2,1c-0.9,0.9-2.3,1.6-4.2,1.2 C467.2,43.2,465.6,40.8,466.2,38z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M484.9,42.8l-4.7-1.1l-0.9,4l-1.6-0.4l2-9.1l1.6,0.4l-0.8,3.7l4.7,1.1l0.8-3.7l1.6,0.4l-2,9.1l-1.6-0.4 L484.9,42.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M499.7,43.1l-4.3,6.3l-0.7-0.2l-1.2-7.5l-1.5,6.9l-1.6-0.4l2-9.1l2.3,0.5l1.1,6.7l3.9-5.6l2.3,0.5l-2,9.1 l-1.6-0.4L499.7,43.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M506.4,42.2l6.2,1.4l-0.3,1.4l-4.6-1l-0.5,2.4l4.6,1l-0.3,1.4l-4.6-1l-0.6,2.5l4.6,1l-0.3,1.4l-6.2-1.4 L506.4,42.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M518.1,47.5l-1.5,6.6l-1.6-0.4l2-9.1l1.6,0.4l3.2,7.5l1.5-6.5l1.6,0.4l-2,9.1l-1.5-0.3L518.1,47.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M440.3,51.6c0.5,0.8,1.3,1.6,2.6,1.9c1.3,0.3,2-0.2,2.1-0.8c0.2-0.8-0.7-1.3-1.8-1.8c-1.4-0.7-3.1-1.5-2.6-3.5 c0.3-1.5,1.9-2.4,3.9-1.9c1.4,0.3,2.5,1,3.1,2l-1.2,1c-0.6-0.9-1.4-1.4-2.4-1.6c-0.9-0.2-1.6,0.1-1.8,0.8c-0.2,0.7,0.7,1.2,1.7,1.7 c1.4,0.7,3.1,1.6,2.7,3.6c-0.3,1.5-1.7,2.6-4.2,2c-1.7-0.4-2.8-1.2-3.4-2.3L440.3,51.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M454.1,49.2l-2.8-0.6l0.3-1.4l7.1,1.6l-0.3,1.4l-2.8-0.6l-1.7,7.7l-1.6-0.4L454.1,49.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M464.7,56.1l-1.6-0.4l-0.8,3.4l-1.6-0.4l2-9.1l4,0.9c1.8,0.4,2.7,1.8,2.3,3.5c-0.4,1.6-1.6,2.3-2.8,2.2 l1.4,4.1L466,60L464.7,56.1z M466.3,51.9l-2.2-0.5l-0.6,2.9l2.2,0.5c0.9,0.2,1.7-0.2,1.9-1.1C467.7,52.9,467.2,52.1,466.3,51.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M474.1,52.2l6.2,1.4l-0.3,1.4l-4.6-1l-0.5,2.4l4.6,1l-0.3,1.4l-4.6-1l-0.6,2.5l4.6,1l-0.3,1.4l-6.2-1.4 L474.1,52.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M484.7,54.6L491,56l-0.3,1.4l-4.6-1l-0.5,2.4l4.6,1l-0.3,1.4l-4.6-1l-0.6,2.5l4.6,1l-0.3,1.4l-6.2-1.4 L484.7,54.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M497.2,58.9l-2.8-0.6l0.3-1.4l7.1,1.6l-0.3,1.4l-2.8-0.6l-1.7,7.7l-1.6-0.4L497.2,58.9z"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M505.6,357.2l1-0.6l0.7,1.3l-1,0.6c0.2,0.7,0.3,1.5,0.1,2.4c-0.5,2.8-2.9,4.3-5.6,3.8s-4.4-2.8-3.9-5.6 c0.5-2.8,2.9-4.3,5.6-3.8C503.8,355.6,504.9,356.3,505.6,357.2z M504.9,359.3l-1.5,0.9l-0.7-1.3l1.5-0.9c-0.5-0.5-1.2-0.9-2-1 c-1.9-0.3-3.5,0.6-3.9,2.4c-0.3,1.9,0.9,3.3,2.8,3.7c1.9,0.3,3.5-0.6,3.9-2.4C505,360.2,505,359.8,504.9,359.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M498.7,350.2l0.3-1.6l5.5,1c1.5,0.3,2.6-0.4,2.8-1.9c0.3-1.5-0.5-2.5-2-2.8l-5.5-1l0.3-1.6l5.6,1 c2.3,0.4,3.6,2,3.1,4.7c-0.5,2.7-2.3,3.7-4.5,3.3L498.7,350.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M501,337.6l1.2-6.3l1.4,0.3l-0.9,4.7l2.4,0.4l0.8-4.6l1.4,0.3l-0.8,4.6l2.5,0.5l0.9-4.7l1.4,0.3l-1.2,6.3 L501,337.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M502.9,326.9l0.8-4.5c0.3-1.7,1.5-2.4,2.8-2.2c1.2,0.2,1.8,1.1,1.8,2c0.3-1,1.5-1.6,2.6-1.4 c1.4,0.3,2.3,1.4,2,3.1l-0.8,4.6L502.9,326.9z M507.5,323.4c0.2-0.8-0.3-1.4-0.9-1.5s-1.3,0.2-1.4,1.1l-0.5,2.6l2.4,0.4 L507.5,323.4z M511.5,324c0.2-0.9-0.2-1.5-1-1.6c-0.7-0.1-1.4,0.2-1.5,1.2l-0.5,2.6l2.5,0.5L511.5,324z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M505.1,315.2l1.2-6.3l1.4,0.3l-0.9,4.7l2.4,0.4l0.8-4.6l1.4,0.3l-0.8,4.6l2.5,0.5l0.9-4.7l1.4,0.3l-1.2,6.3 L505.1,315.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M511.6,305.8c-2.8-0.5-4.4-3-3.9-5.6c0.4-1.9,1.5-2.9,2.8-3.4l0.4,1.5c-0.8,0.3-1.6,1.1-1.8,2.1 c-0.3,1.8,0.8,3.4,2.8,3.7c1.9,0.4,3.6-0.7,3.9-2.5c0.2-1.1-0.2-2-0.9-2.6l1-1.2c1,0.9,1.7,2.2,1.4,4.1 C516.7,304.5,514.4,306.3,511.6,305.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M517.1,287c0.8-0.5,1.6-1.4,1.8-2.7c0.2-1.3-0.3-2-0.9-2.1c-0.8-0.2-1.3,0.8-1.7,1.8c-0.6,1.4-1.4,3.1-3.4,2.8 c-1.5-0.3-2.4-1.8-2.1-3.8c0.3-1.4,0.9-2.5,1.9-3.2l1,1.1c-0.8,0.6-1.4,1.5-1.5,2.5c-0.2,1,0.2,1.6,0.9,1.8 c0.7,0.1,1.1-0.8,1.6-1.8c0.7-1.4,1.5-3.2,3.5-2.8c1.5,0.3,2.6,1.6,2.2,4.1c-0.3,1.7-1.1,2.8-2.1,3.5L517.1,287z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M514.2,273.3l-0.5,2.8l-1.4-0.3l1.3-7.2l1.4,0.3l-0.5,2.8l7.8,1.4l-0.3,1.6L514.2,273.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M520.7,262.4l-0.3,1.6l3.4,0.6l-0.3,1.6l-9.2-1.7l0.7-4c0.3-1.8,1.7-2.8,3.4-2.5c1.6,0.3,2.3,1.5,2.3,2.7 l4-1.6l-0.3,1.9L520.7,262.4z M516.5,261l-0.4,2.2l2.9,0.5l0.4-2.2c0.2-0.9-0.3-1.7-1.2-1.8C517.3,259.5,516.6,260.1,516.5,261z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M516.4,253.2l1.2-6.3l1.4,0.3l-0.9,4.7l2.4,0.4l0.8-4.6l1.4,0.3l-0.8,4.6l2.5,0.5l0.9-4.7l1.4,0.3l-1.2,6.3 L516.4,253.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M518.4,242.5l1.2-6.3l1.4,0.3l-0.9,4.7l2.4,0.4l0.8-4.6l1.4,0.3l-0.8,4.6l2.5,0.5l0.9-4.7l1.4,0.3l-1.2,6.3 L518.4,242.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M522.2,229.8l-0.5,2.8l-1.4-0.3l1.3-7.2l1.4,0.3l-0.5,2.8l7.8,1.4l-0.3,1.6L522.2,229.8z"
}));

var _ref19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M317,377.1l1.1-4c0.5-1.9,2.1-2.6,3.6-2.2c1.5,0.4,2.5,1.8,2,3.7l-0.6,2.4l3.4,0.9l-0.4,1.6L317,377.1z  M319.4,373.7l-0.6,2.2l2.9,0.8l0.6-2.2c0.2-0.9-0.2-1.7-1-1.9C320.4,372.3,319.7,372.8,319.4,373.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M319.9,366.1l0.4-1.6l5.4,1.4c1.4,0.4,2.6-0.2,3-1.7c0.4-1.5-0.3-2.6-1.8-2.9l-5.4-1.4l0.4-1.6l5.5,1.5 c2.2,0.6,3.4,2.3,2.7,4.9c-0.7,2.6-2.5,3.5-4.8,2.9L319.9,366.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M323.3,353.7l0.4-1.6l7.6,2l1.1-4l1.4,0.4l-1.5,5.6L323.3,353.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M325.8,344l0.4-1.6l7.6,2l1.1-4l1.4,0.4l-1.5,5.6L325.8,344z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M332.7,327.1l6.1,4.6l-0.2,0.7l-7.6,0.9l6.8,1.8l-0.4,1.6l-9-2.4l0.6-2.2l6.7-0.8l-5.4-4.1l0.6-2.2l9,2.4 l-0.4,1.6L332.7,327.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M341,316.5l-1.1,4.3l1.6,1.1l-0.5,1.7l-8.1-6l0.5-2l10-1.1l-0.5,1.7L341,316.5z M338.6,320l0.9-3.4l-5,0.5 L338.6,320z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M338.2,307.6l6.6,1.8l-0.4,1.6l-9-2.4l0.4-1.6l7.6-2.9l-6.4-1.7l0.4-1.6l9,2.4l-0.4,1.5L338.2,307.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M340.3,289.9l1.1-4c0.5-1.9,2.1-2.6,3.6-2.2s2.5,1.8,2,3.7l-0.6,2.4l3.4,0.9l-0.4,1.6L340.3,289.9z  M342.7,286.5l-0.6,2.2l2.9,0.8l0.6-2.2c0.2-0.9-0.2-1.7-1-1.9C343.7,285.1,342.9,285.6,342.7,286.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M344.2,274.7c0.7-2.7,3.2-4.1,5.9-3.4s4.2,3.2,3.4,5.9c-0.7,2.7-3.2,4.1-5.9,3.4 C344.9,279.8,343.5,277.4,344.2,274.7z M345.6,275.1c-0.5,1.8,0.6,3.4,2.5,3.9c1.9,0.5,3.6-0.3,4.1-2.1c0.5-1.8-0.6-3.4-2.5-3.9 C347.8,272.4,346.1,273.2,345.6,275.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M353.2,264.2l-0.4,1.6l3.4,0.9l-0.4,1.6l-9-2.4l1.1-4c0.5-1.8,2-2.6,3.6-2.2c1.6,0.4,2.2,1.7,2.1,2.8l4.1-1.3 l-0.5,1.8L353.2,264.2z M349.1,262.5l-0.6,2.2l2.9,0.8l0.6-2.2c0.2-0.9-0.2-1.7-1-1.9C350.1,261.1,349.3,261.6,349.1,262.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M351.6,253l-0.7,2.7l-1.4-0.4l1.9-7.1l1.4,0.4l-0.7,2.7l7.6,2l-0.4,1.6L351.6,253z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M352.5,244.3l1.7-6.2l1.4,0.4l-1.2,4.6l2.3,0.6l1.2-4.5l1.4,0.4l-1.2,4.5l2.5,0.7l1.2-4.6l1.4,0.4l-1.7,6.2 L352.5,244.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M361.8,232.2l-0.4,1.6l3.4,0.9l-0.4,1.6l-9-2.4l1.1-4c0.5-1.8,2-2.6,3.6-2.2c1.6,0.4,2.2,1.7,2.1,2.8l4.1-1.3 l-0.5,1.8L361.8,232.2z M357.7,230.4l-0.6,2.2l2.9,0.8l0.6-2.2c0.2-0.9-0.2-1.7-1-1.9S357.9,229.5,357.7,230.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M366.5,217.9c0.8-0.4,1.7-1.3,2-2.5c0.3-1.3-0.2-2-0.7-2.1c-0.8-0.2-1.3,0.7-1.9,1.7c-0.8,1.4-1.7,3-3.6,2.5 c-1.5-0.4-2.3-2-1.8-4c0.4-1.4,1.1-2.4,2.2-3l0.9,1.2c-0.9,0.5-1.5,1.4-1.7,2.3c-0.2,0.9,0,1.6,0.7,1.8c0.7,0.2,1.2-0.7,1.7-1.7 c0.8-1.4,1.7-3,3.7-2.5c1.5,0.4,2.5,1.8,1.9,4.2c-0.4,1.7-1.3,2.7-2.4,3.3L366.5,217.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M364.7,204l-0.7,2.7l-1.4-0.4l1.9-7.1l1.4,0.4l-0.7,2.7l7.6,2l-0.4,1.6L364.7,204z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M372,193.7l-0.4,1.6l3.4,0.9l-0.4,1.6l-9-2.4l1.1-4c0.5-1.8,2-2.6,3.6-2.2c1.6,0.4,2.2,1.7,2.1,2.8l4.1-1.3 l-0.5,1.8L372,193.7z M367.9,191.9l-0.6,2.2l2.9,0.8l0.6-2.2c0.2-0.9-0.2-1.7-1-1.9S368.2,191,367.9,191.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M368.5,184.1l1.7-6.2l1.4,0.4l-1.2,4.6l2.3,0.6l1.2-4.5l1.4,0.4l-1.2,4.5l2.5,0.7l1.2-4.6l1.4,0.4l-1.7,6.2 L368.5,184.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M371.3,173.6l1.7-6.2l1.4,0.4l-1.2,4.6l2.3,0.6l1.2-4.5l1.4,0.4l-1.2,4.5l2.5,0.7l1.2-4.6l1.4,0.4l-1.7,6.2 L371.3,173.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M376.1,161.3l-0.7,2.7l-1.4-0.4l1.9-7.1l1.4,0.4l-0.7,2.7l7.6,2l-0.4,1.6L376.1,161.3z"
}));

var SvgEnquireMap = function SvgEnquireMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 752 440",
    style: {
      enableBackground: "new 0 0 752 440"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    id: "xduEaf_1_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 511,
    height: 352,
    id: "xduEaf",
    xlinkHref: "850DACFA46013962.jpg",
    transform: "matrix(1.2716 0 0 1.2716 51.1021 0)"
  })), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnquireMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EnquireMap.862ee228.svg";
export { ForwardRef as ReactComponent };